import { render, staticRenderFns } from "./OverviewTips.vue?vue&type=template&id=3dd12fe7&"
import script from "./OverviewTips.vue?vue&type=script&lang=js&"
export * from "./OverviewTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports